import { MouseEvent, useEffect, useState } from "react";
import { Footer, Header, normalize, TITLES } from "./layout";
import { NotFound, PAGES } from "./pages";

export default function App() {
  const [path, setPath] = useState(() => normalize(window.location.pathname));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onPop = () => {
      setPath(normalize(window.location.pathname));
      setOpen(false);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  useEffect(() => {
    document.title = TITLES[path] ?? "WarmNest Counselling";
  }, [path]);

  function onClick(e: MouseEvent<HTMLDivElement>) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    const a = (e.target as HTMLElement).closest("a");
    if (!a || a.target === "_blank" || a.hasAttribute("download")) return;
    const href = a.getAttribute("href");
    if (!href || !href.startsWith("/")) return;
    e.preventDefault();
    const next = normalize(href);
    window.history.pushState({}, "", next);
    setPath(next);
    setOpen(false);
    window.scrollTo(0, 0);
  }

  const Page = PAGES[path] ?? NotFound;
  return (
    <div className="site" onClick={onClick}>
      <Header path={path} open={open} toggle={() => setOpen((v) => !v)} />
      <main><Page key={path} /></main>
      <Footer />
    </div>
  );
}
